

import { interpolateSafe, PhraseMap } from '@ms/yammer-i18n';

export default class InterpolateStrings {

  public static feature: string = 'skiplink';

  private locale: string;
  private phrases: PhraseMap;

  constructor(locale: string, phrases: PhraseMap) {
    this.locale = locale;
    this.phrases = phrases;
  }

  public skiplinkTips(): string {
    return interpolateSafe(this.locale, this.phrases, 'skiplinkTips');
  }

  public skiplinkTipsVE(): string {
    return interpolateSafe(this.locale, this.phrases, 'skiplinkTipsVE');
  }

  public skiplinkSkipTo(): string {
    return interpolateSafe(this.locale, this.phrases, 'skiplinkSkipTo');
  }

  public skiplinkKeyboard(): string {
    return interpolateSafe(this.locale, this.phrases, 'skiplinkKeyboard');
  }

  public skiplinkAlt(): string {
    return interpolateSafe(this.locale, this.phrases, 'skiplinkAlt');
  }

}
